import { TargetAudienceGenderEnum } from "../../../features/surveys-requests/models/enums/TargetAudienceGenderEnum"
import { SurveyAndOpinionPollRequestTypeEnum } from "./enums/SurveyAndOpinionPollRequestTypeEnum"
import { SurveyOpinionTaskStatusEnum } from "./enums/SurveyOpinionTaskStatusEnum"
import { TaskPriorityEnumValues } from "./enums/TaskPriorityEnumValues"

export class SurveyTaskDetails {
  status: Status
  priority: Priority
  taskId: number
  taskNumber: string
  duedate: Date
  ambassadorData: AmbassadorData
  haveAmbassador: boolean
  trackName: string
  creationDate: Date
  updateDate: Date
  approvalDate: Date
  assignedDate: Date
  requestNumber: string
  canViewRequest: boolean
  requestId: number
  modificationReasons: ModificationReason[]
  group: string
  instructions: string
  canDelete: boolean
  suvreyType: SurveyAndOpinionPollRequestTypeEnum
  rejectionReason: string
  lastResponseDate: Date
  requestPurpose: string
  requestPurposeProduct: RequestPurposeProduct
  requestPurposeOperator: RequestPurposeOperator
  surveyName: string
  targetAudience: TargetAudience
}

export class Status {
  title: string
  statusCode: SurveyOpinionTaskStatusEnum
}

export interface ModificationReason {
  title: string
  reason: string
  date: Date
  status: SurveyOpinionTaskStatusEnum
}

export class Priority {
  id: number
  name: string
  code: TaskPriorityEnumValues
  icon: string
}

export class AmbassadorData {
  name: string
  image: string
}

export class RequestPurposeProduct {
  name: string
  logo: string
}

export interface RequestPurposeOperator {
  name: string
  logo: string
}

export class TargetAudience {
  minimumCompletionTime: number
  totalTargetAudience: number
  targetAudienceGender: TargetAudienceGenderEnum
  ageRangeFrom: number
  ageRangeTo: number
  geographicScopes: string[]
  geographicScopesWithRate: GeographicScopesWithRate[]
}
export class GeographicScopesWithRate {
  name: string
  rate: number
  totalRate: number
}
